import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

interface SidebarNavTooltipProps {
  label: string;
  enabled?: boolean;
  children: React.ReactElement;
}

export function SidebarNavTooltip({ label, enabled = true, children }: SidebarNavTooltipProps) {
  if (!enabled) {
    return children;
  }

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side="right"
        sideOffset={10}
        className="border border-[#E7E7E7] bg-white px-3 py-1.5 text-sm font-normal text-[#3D3D3D] shadow-md dark:border-sidebar-border dark:bg-sidebar dark:text-foreground"
      >
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
